import { TableData } from '@cokitchen/cokitchen-components';
import { ExternalRiderType } from 'models/external-rider.model';
import moment from 'moment';
import React from 'react';
import { getUserName } from 'utils/functions';

const ScheduledRiderTableData = ({ rider }: { rider: ExternalRiderType }) => {
  return (
    <>
      <TableData>
        <span>{getUserName(rider)}</span>
      </TableData>
      <TableData>
        <span>
          {rider.schedule_date ? moment(rider.schedule_date).format('DD/MM/YYYY') : 'N/A'}
        </span>
      </TableData>
      <TableData>
        <span>
          {rider.schedule_start_time ? `${rider.schedule_start_time} -` : 'N/A'}
          {rider.schedule_end_time}
        </span>
      </TableData>
      <TableData>
        <span>{rider.schedule_location_name}</span>
      </TableData>
    </>
  );
};

export default ScheduledRiderTableData;
